import React, { useState } from 'react';
import { Checkbox, FormControlLabel, Tooltip, Skeleton, CircularProgress } from '@mui/material';
import { useUpdateComplianceTaskMutation } from '@/features/engagements/engagementsApi';
import { useObjectContext } from '@/hooks/useObjectContext';

export const ComplianceTaskCheckbox = ({ task }) => {
	const { dealId } = useObjectContext();
	const [completed, setIsCompleted] = useState(task?.completed);

	const [updateCompliance, { isLoading }] = useUpdateComplianceTaskMutation();

	const handleChange = async (event) => {
		const isChecked = event.target.checked;
		setIsCompleted(isChecked);
		await updateCompliance({
			dealId,
			isCompleted: isChecked,
			docId: task.documentId,
		});
	};

	return (
		<Tooltip title={task?.questionData?.description}>
			<FormControlLabel
				disabled={isLoading}
				control={
					<Checkbox
						disabled={isLoading}
						checked={completed}
						onChange={handleChange}
						size='small'
						{...(isLoading && { icon: <CircularProgress size={20} /> })}
					/>
				}
				label={task?.questionData?.name}
			/>
		</Tooltip>
	);
};
